import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'sona-legal',
    imports: [RouterOutlet],
    templateUrl: './legal.layout.html',
    styleUrl: './legal.layout.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'c-sona-legal-layout'
    }
})
export class LegalLayout {
}
